import React from 'react';
import API from '../../utils/API';
import 'react-datetime/css/react-datetime.css';
import cityTimezones from 'city-timezones';
import moment from 'moment-timezone';

import InputField from '../../components/inputs/inputField';
import SelectField from '../../components/inputs/selectField';
import ToggleField from '../../components/inputs/toggleField';
import LocationLookup from '../../components/inputs/locationLookup';
import FieldModal from '../../components/modals/fieldModal';

class AddEventModal extends React.Component {
    constructor(props) {
        super(props);

        const eventBranding = {
            accentColor: props.organization.branding.accentColor,
            fontColor: props.organization.branding.fontColor,
            backgroundColor: props.organization.branding.backgroundColor,
            logo: { name: "Organization Logo", preview: props.organization.branding.logo },
        };

        const salesforceIntegration = props.organization.integrations.find(
            (integration) => integration.identifier === 'salesforce'
        );
        
        let sfRegStatus = 'Registered';
        let sfCheckinStatus = 'Checked In';
        let sfNotAttendingStatus = 'Did Not Attend';
        
        if (salesforceIntegration) {
            salesforceIntegration.requiredFields.forEach((field) => {
                if (field.id === 'registeredStatus') sfRegStatus = field.value;
                if (field.id === 'checkedinStatus') sfCheckinStatus = field.value;
                if (field.id === 'didNotAttendStatus') sfNotAttendingStatus = field.value;
            });
        }

        this.state = {
            event: {
                experienceType: 'hybrid',
                name: '',
                startDate: moment().format('MM/DD/YYYY'),
                endTime: '5:00 PM',
                startTime: '8:00 AM',
                endDate: moment().format('MM/DD/YYYY'),
                timezone: '',
                expectedNumberOfAttendees: '',
                allowPublicRegistrations: false
            },
            cityLookup: '',
            requiredFields: {
                name: false,
                startDate: false,
                endDate: false,
                timezone: false,
                expectedNumberOfAttendees: false,
            },
            selectedVenue: null,
            eventBranding: eventBranding,
            submitting: false,
            submitError: '',
            salesforceEnabled: salesforceIntegration ? true : false,
            salesforceToggled: false,
            salesforceCampaign: '',
            salesforceRegistrationStatus: sfRegStatus,
            salesforceCheckedinStatus: sfCheckinStatus,
            salesforceNotAttendingStatus: sfNotAttendingStatus,
            isConflictsEventName: false,
            formIsValid: false,
        };
    }

    validateForm = () => {
        const { event, requiredFields, salesforceToggled, salesforceCampaign } = this.state;
        
        let formIsValid = true;
        
        // Check required fields
        Object.keys(requiredFields).forEach((key) => {
            if (!event[key] || event[key] === '') {
                formIsValid = false;
            }
        });

        // Ensure expectedNumberOfAttendees is a number greater than 0
        const attendees = Number(event.expectedNumberOfAttendees);
        if (isNaN(attendees) || attendees <= 0) {
            formIsValid = false;
        }
        
        // Check salesforce fields if toggled
        if (salesforceToggled && (!salesforceCampaign || salesforceCampaign === '')) {
            formIsValid = false;
        }
        
        this.setState({ formIsValid });
    }

    validateEventName = async (value) => {
        if (!value || value.trim() === '') {
            this.setState({ isConflictsEventName: false }, this.validateForm);
            return;
        }

        const valueWithoutSpaces = value.replace(/\s+/g, '');
        try {
            const orgId = this.props.organization._id;
            const response = await API().post(`Organizations/${orgId}/reservePath`, {
                name: valueWithoutSpaces.toLowerCase()
            });

            this.setState({
                isConflictsEventName: response.data === true,
            }, this.validateForm);
        } catch (error) {
            console.error("Error validating path:", error);
            this.setState({
                isConflictsEventName: true,
            }, this.validateForm);
        }
    }

    createEvent = async () => {
        const { handleSubmit } = this.props;
        const { event, selectedVenue, salesforceToggled } = this.state;
        
        // Only add salesforce integrations if toggled
        if (salesforceToggled) {
            event.integrations = {
                salesforce: {
                    campaignName: this.state.salesforceCampaign,
                    registrationStatus: this.state.salesforceRegistrationStatus,
                    checkinStatus: this.state.salesforceCheckedinStatus,
                    notAttendedStatus: this.state.salesforceNotAttendingStatus,
                }
            };
        }

        this.setState({ submitting: true, submitError: '' });
		event.members = [];
        try {
        let success = true;
        // Handle venue scenarios
        if (selectedVenue) {
            if (!selectedVenue.platform) {
                success = await handleSubmit(event, selectedVenue, false, []);
            } else {
                success = await handleSubmit({ ...event, venue: selectedVenue.value }, null, false, []);
            }
        } else {
            success = await handleSubmit(event, null, false, []);
        }

		if (!success) {
			this.setState({ submitting: false });
                return;
            }
        } catch (e) {
            const message =  e.response.data || 'Request failed.';
            this.setState({ submitting: false, submitError: message });
            return;
        }
    };

    render() {
        const { event, cityLookup, requiredFields, salesforceEnabled, isConflictsEventName, formIsValid, submitting } = this.state;
        const { name, startDate, endDate, timezone, experienceType } = event;
        const { isOpen, toggle } = this.props;

        return (
            <FieldModal
                isOpen={isOpen}
                toggle={toggle}
                size="medium"
                actionButton={this.createEvent}
                actionButtonLabel={submitting ? 'Creating Event...' : 'Create Event'}
                actionButtonDisabled={!formIsValid || isConflictsEventName || submitting}
                bodyContent={() => {
                    const cityTimezoneOptions = cityLookup !== ''
                        ? cityTimezones.findFromCityStateProvince(cityLookup).map((tz) => ({
                            label: `${tz.city}, ${tz.province}`, 
                            value: tz.timezone
                        }))
                        : [];

                    return (
                        <div className="sectionBody w-100">
                            <div style={{ textAlign: 'center' }}>
                                <h1>Create New Event</h1>
                                <div className='mb-20 mt-10'>
                                    <p className='mb-10'>Please enter the information below to set up your experience</p>
                                </div>
                            </div>

                            <div className='flex flex-wrap jcc' style={{ overflowX: 'hidden', maxHeight: 'calc(100% - 96px)' }}>
                                <div className="sectionBlock mr-15 mb-15" style={{ maxWidth: 600, paddingLeft: 1 }}>
                                    <InputField
                                        label={'Event Name'}
                                        required={true}
                                        errorTrigger={requiredFields.name || isConflictsEventName}
                                        errorMessage={"Event name not supported"}
                                        value={name}
                                        onChange={(e) => {
                                            const updatedEvent = {...event, name: e.target.value};
                                            this.setState({ event: updatedEvent }, this.validateForm);
                                        }}
                                        onBlur={(e) => this.validateEventName(e.target.value)}
                                    />
                                    
                                    <div className="flex-sb w-100">
                                        <div className="mr-10 w-100">
                                            <InputField
                                                label={'Start Date'}
                                                defaultValue={moment(startDate).format('yyyy-MM-DD')}
                                                min={moment().format('yyyy-MM-DD')}
                                                required={true}
                                                errorTrigger={requiredFields.startDate}
                                                type={'date'}
                                                inputIcon={<i className="lar la-calendar" />}
                                                onChange={(e) => {
                                                    const updatedEvent = {
                                                        ...event,
                                                        startDate: moment(e.target.value).format('MM/DD/YYYY')
                                                    };
                                                    this.setState({ event: updatedEvent }, this.validateForm);
                                                }}
                                            />
                                        </div>

                                        <div className="ml-10 w-100">
                                            <InputField
                                                label={'End Date'}
                                                defaultValue={moment(endDate).format('yyyy-MM-DD')}
                                                min={moment(startDate).format('yyyy-MM-DD')}
                                                required={true}
                                                errorTrigger={requiredFields.endDate}
                                                type={'date'}
                                                inputIcon={<i className="lar la-calendar" />}
                                                onChange={(e) => {
                                                    const updatedEvent = {
                                                        ...event,
                                                        endDate: moment(e.target.value).format('MM/DD/YYYY')
                                                    };
                                                    this.setState({ event: updatedEvent }, this.validateForm);
                                                }}
                                            />
                                        </div>
                                    </div>
                                    
                                    <ToggleField 
                                        label="This will be a virtual only event" 
                                        icons={false} 
                                        checked={experienceType === 'virtual'} 
                                        onChange={(e) => {
                                            const type = e.target.checked ? 'virtual' : 'hybrid';
                                            const updatedEvent = {...event, experienceType: type};
                                            this.setState({ event: updatedEvent }, this.validateForm);
                                        }} 
                                    />
                                    
                                    {(experienceType === 'in-person' || experienceType === 'hybrid') && (
                                        <LocationLookup
                                            selectedPlace={this.state.selectedVenue}
                                            locations={this.props.locations}
                                            label="Location Finder"
                                            placeholder={<p className='grey'><i>Search for the venue where the event will take place</i></p>}
                                            noOptionsMessage="No results" 
                                            onSelect={(location) => {
                                                let updatedEvent = {...event};
                                                if (location.timezone) {
                                                    updatedEvent.timezone = location.timezone;
                                                }
                                                this.setState({ 
                                                    selectedVenue: location,
                                                    event: updatedEvent 
                                                }, this.validateForm);
                                            }}
                                            classes="w-100"
                                        />
                                    )}

                                    <SelectField
                                        label={'Timezone'}
                                        value={timezone ? {
                                            value: timezone, 
                                            label: <p>
                                                {timezone}
                                                <span className='grey'><i>{` (${moment().tz(timezone).zoneAbbr()})`}</i></span>
                                            </p>
                                        } : null}
                                        placeholder="Search for nearest city"
                                        name="timezones"
                                        classes="w-100"
                                        options={cityTimezoneOptions}
                                        required={true}
                                        errorTrigger={requiredFields.timezone}
                                        onInputChange={(text) => this.setState({ cityLookup: text })}
                                        noOptionsMessage={({ inputValue }) =>
                                            !inputValue ? 'Type city name to get options' : 'No cities match your search'}
                                        onChange={(timezone) => {
                                            const updatedEvent = {...event, timezone: timezone.value};
                                            this.setState({ event: updatedEvent }, this.validateForm);
                                        }}
                                    />

                                    <div className="w-100">
                                        <InputField
                                            label={'How Many Attendees Are You Expecting?'}
                                            value={event.expectedNumberOfAttendees}
                                            min={1}
                                            required={true}
                                            errorTrigger={requiredFields.expectedNumberOfAttendees}
                                            errorMessage={"Must be greater than 0"}
                                            type={'number'}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                // Don't allow negative values
                                                if (value.includes('-')) return;
                                                
                                                const updatedEvent = {
                                                    ...event,
                                                    expectedNumberOfAttendees: value
                                                };
                                                this.setState({ event: updatedEvent }, this.validateForm);
                                            }}
                                        />
                                    </div>

                                    {salesforceEnabled && (
                                        <div>
                                            <h3 className='blockHeader'>Salesforce</h3>
                                            <p className='small gray mb-10'>Connect to Salesforce to sync attendee data and create new leads.</p>
                                            
                                            <ToggleField 
                                                icons={false} 
                                                label="Enable Salesforce Integration" 
                                                checked={this.state.salesforceToggled} 
                                                onChange={(e) => {
                                                    const checked = e.target.checked;
                                                    this.setState({ 
                                                        salesforceToggled: checked,
                                                        salesforceCampaign: checked ? this.state.salesforceCampaign : '' 
                                                    }, this.validateForm);
                                                }} 
                                            />
                                            
                                            {this.state.salesforceToggled && (
                                                <div className="w-100">
                                                    <InputField
                                                        label={'Campaign Name'}
                                                        value={this.state.salesforceCampaign}
                                                        placeholder={'Name the Salesforce campaign for this event'}
                                                        required={true}
                                                        errorTrigger={!this.state.salesforceCampaign}
                                                        inputIcon={<i className="lab la-salesforce" />}
                                                        onChange={(e) => {
                                                            this.setState({ salesforceCampaign: e.target.value }, this.validateForm);
                                                        }}
                                                    />

                                                    <InputField
                                                        label={'Registration Status'}
                                                        value={this.state.salesforceRegistrationStatus}
                                                        placeholder={'Registered'}
                                                        onChange={(e) => {
                                                            this.setState({ salesforceRegistrationStatus: e.target.value });
                                                        }}
                                                    />

                                                    <InputField
                                                        label={'Checked In Status'}
                                                        value={this.state.salesforceCheckedinStatus}
                                                        placeholder={'Checked In'}
                                                        onChange={(e) => {
                                                            this.setState({ salesforceCheckedinStatus: e.target.value });
                                                        }}
                                                    />

                                                    <InputField
                                                        label={'Did Not Attend Status'}
                                                        value={this.state.salesforceNotAttendingStatus}
                                                        placeholder={'Did Not Attend'}
                                                        onChange={(e) => {
                                                            this.setState({ salesforceNotAttendingStatus: e.target.value });
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                            {this.state.submitError && (
                                <div className="formFieldLabel error" style={{textAlign: 'center' }}>
                                    <p><strong>Error:</strong> {this.state.submitError}</p>
                                </div>
                            )}
                        </div>
                    );
                }}
            />
        );
    }
}

export default AddEventModal;